"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ExpenseKindEnum = void 0;
var ExpenseKindEnum;
(function (ExpenseKindEnum) {
    ExpenseKindEnum["RECURRING_SUBSCRIPTION"] = "RecurringSubscription";
    ExpenseKindEnum["ONE_TIME_EXPENSE"] = "OneTimeExpense";
    ExpenseKindEnum["REIMBURSEMENT"] = "Reimbursement";
    ExpenseKindEnum["SUBSCRIPTION"] = "Subscription";
    ExpenseKindEnum["HOSPITALITY"] = "Hospitality";
    ExpenseKindEnum["PER_DIEM"] = "PerDiem";
    ExpenseKindEnum["STANDARD"] = "Standard";
    ExpenseKindEnum["MILEAGE"] = "Mileage";
    ExpenseKindEnum["TRIP_FOLDER"] = "TripFolder";
})(ExpenseKindEnum = exports.ExpenseKindEnum || (exports.ExpenseKindEnum = {}));
